<template>
 
  <div class="comment-vote" v-if="itData">

    <div class="vote-info cf" v-if="itData.star>0">
      <div class="score">
          <em class="value">{{itData.star}}<sup>&reg;</sup></em>
          <div class="starbar"><span :style="{width:starbar(itData.star/10)}"></span></div>
      </div>
      <div class="detail">
          <ul class="mod-ul">
              <li class="mod-li">
                <em>5星</em>
                <div class="rating-bar">
                  <span :style="{width:starbar(itData.star_usernum_5/itData.star_usernum)}"></span>
                </div>
              </li>
              <li class="mod-li">
                <em>4星</em>
                <div class="rating-bar">
                  <span :style="{width:starbar(itData.star_usernum_4/itData.star_usernum)}"></span>
                </div>
              </li>
              <li class="mod-li">
                <em>3星</em>
                <div class="rating-bar">
                  <span :style="{width:starbar(itData.star_usernum_3/itData.star_usernum)}"></span>
                </div>
              </li>
              <li class="mod-li">
                <em>2星</em>
                <div class="rating-bar">
                  <span :style="{width:starbar(itData.star_usernum_2/itData.star_usernum)}"></span>
                </div>
              </li>
              <li class="mod-li">
                <em>1星</em>
                <div class="rating-bar">
                  <span :style="{width:starbar(itData.star_usernum_1/itData.star_usernum)}"></span>
                </div>
              </li>
          </ul>
          <template v-if="itData.count>0">
            <p class="total" v-if="!isInner"><a class="" @click="toList">{{itData.count| numFormat}}人评价</a></p>
            <p class="total inner" v-else><a class="">{{itData.count | numFormat}}人评价</a></p>
          </template>
   
      </div>            
  </div>    
  <div class="vote-none" v-if="itData.star==0">还没收集到足够评分，无法给出公正的评分</div>
  <div class="vote-new" v-else>
    最新玩家评分<span>{{itData.recent_user_star>0?itData.recent_user_star:'暂无'}}</span> /   近7天评分<span>{{itData.recent_day_star>0?itData.recent_day_star:'暂无'}}</span>
  </div>
  </div>
</template>

<script>
import Tool from '@/tool/tool';

export default {
  name: 'Cstar',
  props: {
    score: Number,//评分值--页面传入
    itData: Object,//星级数据
    isInner:{
      type: Boolean,
      default: false
    }
  },

  methods:{
    starbar(num){
      return Tool.ToolPercent(num);
    },
    popdown(){
      window.comInit.downTips();
    },
    //跳转评论
    toList(){
      if(window.pjPanel){
        window.pjPanel();
      }      
    }
  }
  
}
</script>


